import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[data-slideMenu]'
})
export class SlideMenuDirective { 

  constructor(private el: ElementRef) { }

    @HostListener('click', ['$event']) onClick($event){
      if ($($event.target).prop("tagName") == "A"){
        if ($($event.target).hasClass("open")){
          $($event.target).next("ul").slideUp(400);
        } else {
          $($event.target).next("ul").slideDown(400);
        }
      } else {
        if ($($event.target).parent("a").hasClass("open")){
          $($event.target).parent("a").next("ul").slideUp(400);
        } else {
          $($event.target).parent("a").next("ul").slideDown(400);
        }
      } 
    }
}
